import * as Yup from "yup";

import { trans } from "src/translations";
import { colorRegex, resolutionRegex } from "utils/validation";

import { FIELDS, MANIFEST_ERROR_FIELD, META_FIELDS } from "./constants";

export const VALIDATION_SCHEMA = Yup.object()
  .shape({
    [FIELDS.zoom.name]: Yup.number().min(
      FIELDS.zoom.min,
      trans.ERROR__MIN_VALUE({ min: FIELDS.zoom.min })
    ),
    [FIELDS.resolution.name]: Yup.string().when({
      is: (exists) => Boolean(exists),
      then: (schema) =>
        schema.test(
          "resolution",
          trans.APP_DETAILS_MANIFEST__VALIDATION_RESOLUTION_ERROR(),
          (value) => resolutionRegex.test(value)
        ),
    }),
    [FIELDS.default_background_color.name]: Yup.string().when({
      is: (exists) => Boolean(exists),
      then: (schema) =>
        schema.test(
          "background-color",
          trans.APP_DETAILS_MANIFEST__VALIDATION_COLOR_ERROR(),
          (value) => colorRegex.test(value)
        ),
    }),
    [FIELDS.key_remapping.name]: Yup.array().of(
      Yup.object().shape({
        key: Yup.string().required(trans.ERROR__FIELD_REQUIRED()),
        value: Yup.mixed().required(trans.ERROR__FIELD_REQUIRED()),
      })
    ),
    [FIELDS.custom.name]: Yup.array().of(
      Yup.object().shape({
        key: Yup.string().required(trans.ERROR__FIELD_REQUIRED()),
        value: Yup.mixed().required(trans.ERROR__FIELD_REQUIRED()),
        description: Yup.string().required(trans.ERROR__FIELD_REQUIRED()),
      })
    ),
    [FIELDS.user_script.name]: Yup.string().test(
      "contains the metadata block",
      trans.APP_DETAILS_MANIFEST__VALIDATION_USER_SCRIPT_METADATA(),
      (value) => {
        if (!value) {
          return true;
        }

        // This regex is designed to match a block of text from this spec: https://wiki.greasespot.net/Metadata_Block#Syntax
        const metadataRegex =
          /^\/\/\s*==UserScript==\s+(?:^\/\/\s*@(\S+)(?:\s+(.+))?\s+)*^\/\/\s*==\/UserScript==/gm;
        return metadataRegex.test(value);
      }
    ),
    [META_FIELDS.appId]: Yup.string().required(trans.ERROR__FIELD_REQUIRED()),
    [META_FIELDS.targets]: Yup.object().required(trans.ERROR__FIELD_REQUIRED()),
  })
  .test("at-least-one-field-in-manifest-attributes", "Error", (object, ctx) => {
    const {
      [FIELDS.app_icon.name]: appIcon,
      [META_FIELDS.appId]: appId,
      [META_FIELDS.appMode]: _appMode,
      [META_FIELDS.targets]: targets,
      ...restValues
    } = object;

    let otherFieldsCount = Object.values(restValues).filter(
      (value) =>
        value !== "" &&
        value !== undefined &&
        !(Array.isArray(value) && value.length === 0)
    ).length;

    if (appIcon?.url) {
      otherFieldsCount++;
    }

    if (otherFieldsCount === 0) {
      return ctx.createError({
        path: MANIFEST_ERROR_FIELD,
        message: "Missing manifest payload",
      });
    }
    return true;
  });
